var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"head"},[_c('div',{staticClass:"title"},[_c('h2',[_vm._v(_vm._s(_vm.title_data.title_1))]),_c('h3',[_vm._v(_vm._s(_vm.title_data.title_2))])]),(_vm.title_data.title_desc)?_c('p',{staticClass:"title_info"},[_vm._v(" "+_vm._s(_vm.title_data.title_desc)+" ")]):_vm._e()]),_c('van-divider',{style:({
      color: '#1d1d1f',
      borderColor: '#1d1d1f',
    })},[_c('i',{staticClass:"iconfont icon_line",class:_vm.title_data.icon})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }